export default __webpack_public_path__ + "static/media/round-boxim2.7f440fd1.png";